import React from 'react'
import config from 'app/config'
import Modal from 'components/Modals'
import { IconClose } from 'components/Zui/Icon'
import './index.css'

function AppVersion({ onClose }) {
    return (
        <Modal>
            <div className="about-screen-wrapper">
                <div className="top-section">
                    <div className="close-section">
                        <div className="close-icon-wrapper">
                            <IconClose onClick={onClose} />
                        </div>
                    </div>
                    <div className="logo-wrappper">
                        <zui-zeiss-logo size="s80"></zui-zeiss-logo>
                    </div>
                    <div className="software-name">
                        <span>Zeiss Surgical Cloud</span>
                    </div>
                </div>
                <div className="bottom-section">
                    <div className="app-vesion-content">
                        <span>Zeiss Surgical Cloud {config.BUILD_NUMBER}</span>
                    </div>
                    <div className="app-copyright-content">
                        <span>Copyright © Carl Zeiss, 2002-2022. All rights reserved.</span>
                    </div>
                </div>
            </div>
        </Modal>
    )
}

export default AppVersion
